import { Options, Vue } from 'vue-class-component';
import { Inject, Prop, Watch } from 'vue-property-decorator';
// import AccountInfoPanel from '@/shared/components/page-header/account-info-panel/index.vue';
import AlertBox from '@/shared/components/alert-box/index.vue';
import { EventEmitter } from 'events';
import { API_URL, SOURCE_BRANCH } from '@/trust-atcs-app/config/config';
import { AppInsights } from '@/trust-atcs-app/appInsights';
import { TrustAPI } from '@/shared/modules/trust-api';
import store from '@/trust-atcs-app/store';
import { RouteN } from '@/trust-atcs-app/constants/router-name';
import AccountInfoPanel from '../account-info-panel/index.vue';
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';


@Options({
  components: {
    AccountInfoPanel,
    AlertBox,
  },
  mixins: [FormatDateTimeMixin],
})
export default class PageHeader extends Vue {
  private ai = new AppInsights;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop({ default: true })
  private showAppMenu!: boolean;

  @Prop({ default: null })
  private isExternal!: boolean;

  private showCancelAlertBox = false;
  private alertBoxTitle = '';
  private alertBoxBody = 'Are you sure you want to cancel?';

  private appName = '';

  private sourceBranch = SOURCE_BRANCH;
  private apiURL = API_URL;
  public apiBranch = '';
  private isToday = false;
  private showDateTip = true;


  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  @Watch('$route.name')
  private onRouteChanged(): void {
    this.setAppName();
  }

  mounted(): void {
    // this.eventCtrl.on('cancel-adjustment', this.closeAdjustment);
    // this.eventCtrl.on('cancel-update', this.cancelUpdate);
    this.eventCtrl.on('cancel-pc-renew', this.cancelApplication);
    this.eventCtrl.on('cancel-pc-no-renew', this.cancelApplication);
    this.eventCtrl.on('cancel-sm-application', this.cancelApplication);
    this.eventCtrl.on('cancel-sar-application', this.cancelApplication);
    this.eventCtrl.on('cancel-sanr-application', this.cancelApplication);
    this.eventCtrl.on('cancel-amn-application', this.cancelApplication);
    this.eventCtrl.on('cancel-amr-application', this.cancelApplication);
    this.eventCtrl.on('cancel-stn-application', this.cancelApplication);
    this.eventCtrl.on('cancel-str-application', this.cancelApplication);
    this.eventCtrl.on('cancel-stn-fromlink', this.cancelSTApplication);
    this.eventCtrl.on('cancel-str-fromlink', this.cancelSTApplication);
    this.setAppName();
    this.getSystemDate();
    if (this.env.length > 0) {
      setInterval(() => {
        this.getSystemDate();
      }, 10000);
    }
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('cancel-pc-renew', this.cancelApplication);
    this.eventCtrl.removeListener('cancel-pc-no-renew', this.cancelApplication);
    this.eventCtrl.removeListener('cancel-sm-application', this.cancelApplication);
    this.eventCtrl.removeListener('cancel-sar-application', this.cancelApplication);
    this.eventCtrl.removeListener('cancel-sanr-application', this.cancelApplication);
    this.eventCtrl.removeListener('cancel-amn-application', this.cancelApplication);
    this.eventCtrl.removeListener('cancel-amr-application', this.cancelApplication);
    this.eventCtrl.removeListener('cancel-stn-application', this.cancelApplication);
    this.eventCtrl.removeListener('cancel-str-application', this.cancelApplication);
    this.eventCtrl.removeListener('cancel-amr-application', this.cancelApplication);
    this.eventCtrl.removeListener('cancel-stn-fromlink', this.cancelSTApplication);
    this.eventCtrl.removeListener('cancel-str-fromlink', this.cancelSTApplication);
  }

  private setAppName() {
    this.appName = 'ANNUAL TRUST COMPLIANCE SUBMISSION';
  }

  private cancelApplication(): void {
    this.alertBoxTitle = "CANCEL APPLICATION";
    this.alertBoxBody = 'By cancelling the application all progress will be lost. Are you sure you want to cancel?';
    if (this.isConfirmationPage) {
      this.exitApplication();
    } else {
      this.showCancelAlertBox = true;
    }
  }

  private cancelSTApplication(): void {
    this.alertBoxTitle = "CANCEL APPLICATION";
    this.alertBoxBody = 'By selecting the "Associate Membership Application" link, you will be directed back to the MY LAW SOCIETY portal, and your current application will be cancelled. Once on the portal, locate the Associate Membership card and click the \'Apply Now\' button.<br /><br />Do you wish to continue?';
    if (this.isConfirmationPage) {
      this.exitApplication();
    } else {
      this.showCancelAlertBox = true;
    }
  }

  // private cancelPcRenew() {
  //   this.alertBoxTitle = "CANCEL APPLICATION";
  //   this.alertBoxBody = 'By cancelling the application all progress will be lost. Are you sure you want to cancel?';
  //   if (this.isConfirmationPage) {
  //     this.exitApplication();
  //   } else {
  //     this.showCancelAlertBox = true;
  //   }
  // }

  // private cancelPcNoRenew() {
  //   this.alertBoxTitle = "CANCEL APPLICATION";
  //   this.alertBoxBody = 'By cancelling the application all progress will be lost. Are you sure you want to cancel?';
  //   if (this.isConfirmationPage) {
  //     this.exitApplication();
  //   } else {
  //     this.showCancelAlertBox = true;
  //   }
  // }

  // private cancelSmApplication() {
  //   this.alertBoxTitle = "CANCEL APPLICATION";
  //   this.alertBoxBody = 'By cancelling the application all progress will be lost. Are you sure you want to cancel?';
  //   if (this.isConfirmationPage) {
  //     this.exitApplication();
  //   } else {
  //     this.showCancelAlertBox = true;
  //   }
  // }

  // private cancelSarApplication() {
  //   this.alertBoxTitle = "CANCEL APPLICATION";
  //   this.alertBoxBody = 'By cancelling the application all progress will be lost. Are you sure you want to cancel?';
  //   if (this.isConfirmationPage) {
  //     this.exitApplication();
  //   } else {
  //     this.showCancelAlertBox = true;
  //   }
  // }

  // private cancelAmnApplication() {
  //   this.alertBoxTitle = "CANCEL APPLICATION";
  //   this.alertBoxBody = 'By cancelling the application all progress will be lost. Are you sure you want to cancel?';
  //   if (this.isConfirmationPage) {
  //     this.exitApplication();
  //   } else {
  //     this.showCancelAlertBox = true;
  //   }
  // }

  // private cancelAmrApplication() {
  //   this.alertBoxTitle = "CANCEL APPLICATION";
  //   this.alertBoxBody = 'By cancelling the application all progress will be lost. Are you sure you want to cancel?';
  //   if (this.isConfirmationPage) {
  //     this.exitApplication();
  //   } else {
  //     this.showCancelAlertBox = true;
  //   }
  // }

  private async exitApplication(): Promise<void> {

    try {
      this.showCancelAlertBox = false;
      // clear all application data
      const _appId = store.getters.getAppRenew.id;
      // if (this.$route.name == RouteN.Mars.PcRenew.n || this.$route.name == RouteN.Mars.PcRenewOverview.n) {
      //   await this.apiService.PcRenewApi?.apiV2PcRenewCancelPcRenewApplicationApplicationIdGet(_appId);
      // } else if (this.$route.name == RouteN.Mars.PcNoRenew.n) {
      //   await this.apiService.PcNonRenewApi?.apiV2PcNonRenewCancelPcRenewApplicationApplicationIdGet(_appId);
      // } else if (this.$route.name == RouteN.Mars.SmApplication.n) {
      //   await this.apiService.SmApi?.apiV2SmCancelSmApplicationApplicationIdGet(_appId);
      // } else if (this.$route.name == RouteN.Mars.SarApplication.n) {
      //   await this.apiService.SpecAccRenewApi?.apiV2SpecAccRenewCancelApplicationApplicationIdGet(_appId);
      // } else if (this.$route.name == RouteN.Mars.SaNrApplication.n) {
      //   await this.apiService.SpecAccNonRenewApi?.apiV2SpecAccNonRenewCancelApplicationApplicationIdGet(_appId);
      // } else if (this.$route.name == RouteN.Mars.AmnApplication.n) {
      //   await this.apiService.AmNewApi?.apiV2AmNewCancelAmNewApplicationApplicationIdGet(_appId);
      // } else if (this.$route.name == RouteN.Mars.StnApplication.n) {
      //   await this.apiService.StudentNewApi?.apiV2StudentNewCancelStudentNewApplicationApplicationIdGet(_appId);
      // } else if (this.$route.name == RouteN.Mars.StrApplication.n) {
      //   await this.apiService.StudentRenewApi?.apiV2StudentRenewCancelStudentRenewApplicationApplicationIdGet(_appId);
      // } else if (this.$route.name == RouteN.Mars.AmrApplication.n) {
      //   await this.apiService.AmRenewApi?.apiV2AmRenewCancelAmRenewApplicationApplicationIdGet(_appId);
      // }
    } catch (err) {
      console.log(err);
    } finally {
      window.sessionStorage.clear();
      store.dispatch('setPcrFormData', {});
      this.$router.push({ name: RouteN.ATCS.Home.n });
    }
  }

  get isConfirmationPage(): boolean {
    const section: string = this.$route.query.sec as string || '';
    return section.indexOf('confirmation') > -1;
  }

  get env(): string {
    const local = window.location.href.indexOf('localhost') > 0 ? 'DEV' : '';
    const dev = window.location.href.indexOf('-dev') > 0 ? 'DEV' : '';
    const sit = window.location.href.indexOf('-sit') > 0 ? 'SIT' : '';
    return local + dev + sit;
  }

  get isSameBranchName(): boolean {
    return this.sourceBranch == this.apiBranch;
  }

  private displayDate = new Date();

  private isDateToday(dateString: string) {
    // Parse the date string into a Date object
    const date = new Date(dateString);

    // Get today's date
    const today = new Date();

    // Compare years, months, and days
    return (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()
    );
  }

  private getSystemDate(): void {
    if (this.showDateTip) {
      this.apiService?.DateApi.apiV2DateGetBaseDateGet()
        .then((res: any) => {
          this.displayDate = new Date(res.data);
          this.isToday = this.isDateToday((this.displayDate.toISOString()));
        })
        .catch((err: any) => {
          this.ai.trackException('Get date failed: ' + err);
          console.log('Get date failed: ', err);
        })
    }
  }

}
